module.exports = __webpack_public_path__ + "img/db-clients.e010ac50.png";